/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from 'react';
import classnames from 'classnames';
import { useUIData } from '../hooks/useUIData';
import { Link } from 'react-router-dom';

interface ISideSubMenuProps {
  title: string;
  active?: boolean;
  iconClass: string;
}

const SideSubMenu: React.FunctionComponent<ISideSubMenuProps> = (props) => {
  const [expanded, setExpanded] = React.useState(false);
  const ui = useUIData();
  return (
    <>
      <Link
        to={`#${props.title}`}
        className={classnames({
          'd-flex align-items-center dropdown-toggle': true,
          active: props.active,
          in: expanded && ui.sideMenuExpanded,
        })}
        onClick={() => {
          setExpanded(!expanded);
          if (!ui.sideMenuExpanded) {
            ui.changeSideMenuExpandedStatus(!ui.sideMenuExpanded);
          }
        }}
      >
        <i
          className={classnames({
            'mr-lg-3 mr-2 font-lg': true,
            [props.iconClass]: true,
          })}
        ></i>
        {props.title}
        <i className="icon-chevron-down ml-auto text-right font-xxs"></i>
        {!ui.sideMenuExpanded && (
          <i className="icon-caret-right font-xxxxs"></i>
        )}
      </Link>
      <ul
        className={classnames({
          'list-unstyled m-0 pb-2 menu-dropdown': true,
          in: expanded && ui.sideMenuExpanded,
        })}
      >
        {props.children}
        <a id={props.title} className="p-0"></a>
      </ul>
    </>
  );
};

export default SideSubMenu;
